import { render } from "./StrategyComponent.vue?vue&type=template&id=0c4097ec&scoped=true&ts=true"
import script from "./StrategyComponent.vue?vue&type=script&lang=ts"
export * from "./StrategyComponent.vue?vue&type=script&lang=ts"

import "./StrategyComponent.vue?vue&type=style&index=0&id=0c4097ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4097ec"]])

export default __exports__